var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkSendSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 57.5,
    r: 57.5,
    fill: "#E7F9F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.5017 98.2592C68.3118 98.2592 78.6791 93.9649 86.323 86.321C93.9669 78.6772 98.2612 68.3098 98.2612 57.4997C98.2612 46.6896 93.9669 36.3223 86.323 28.6784C78.6791 21.0345 68.3118 16.7402 57.5017 16.7402C46.6916 16.7402 36.3243 21.0345 28.6804 28.6784C21.0365 36.3223 16.7422 46.6896 16.7422 57.4997C16.7422 68.3098 21.0365 78.6772 28.6804 86.321C36.3243 93.9649 46.6916 98.2592 57.5017 98.2592ZM75.4932 50.0165L55.1134 70.3963C53.6168 71.8929 51.1967 71.8929 49.716 70.3963L39.5261 60.2064C38.0295 58.7098 38.0295 56.2897 39.5261 54.809C41.0227 53.3283 43.4428 53.3123 44.9236 54.809L52.4067 62.2922L70.0798 44.6032C71.5764 43.1065 73.9965 43.1065 75.4773 44.6032C76.958 46.0998 76.9739 48.5199 75.4773 50.0006L75.4932 50.0165Z",
    fill: "#1DA881"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkSendSuccess);
export default __webpack_public_path__ + "static/media/link-send-success.6e55200f62d8e6d650aa8257ef800d87.svg";
export { ForwardRef as ReactComponent };